<script>
  export let title;
  export let changes;

  // Set the default limit for how many records to show.
  const limit = 5;
  let showAll = false;
  // flip the toggle on each click
  function onToggle() {
    showAll = !showAll;
  }
</script>

<h2>{title}</h2>
<ul>
  {#each changes as obj, idx}
    <li class:display-none={idx + 1 > limit && !showAll}>
      <b>{obj.date}</b>
      {@html obj.description}
    </li>
  {/each}
</ul>
<div class="text-center">
  <button class="btn" on:click={onToggle}>
    {showAll ? 'Show less' : 'Show all'}
  </button>
</div>
